// Match the same decoded, case-insensitive document route in Express and Vite.
// Only this document is forwarded; /index.html stays with Vite to avoid a loop.
export function isDataCoverageDocumentPath(path) {
  try {
    return decodeURIComponent(path.split("?")[0]).replace(/\/+$/, "").toLowerCase() === "/reports/data-coverage";
  } catch {
    return false;
  }
}
